<template>
  <portal-page-template :page="page" theme="purple">
    <!-- Filter and Articles Section -->
    <portal-filter-block
      filter-type="category"
      title="Lärorik information för vuxna"
      description="Filtrera ariklar per kategori:"
      :categories="categories"
      :portal-id="portalEntry?.sys?.id || 'portal-vuxen'"
      theme="purple"
    />
  </portal-page-template>
</template>

<script lang="ts" setup>
import type { Category } from '@/types/contentful'
import {
  transformContentfulCategory,
  transformContentfulPortal,
} from '@/utils/contentfulTransformers'

// Get Contentful client
const { getPortalBySlug, getCategories } = useContentful()

// Fetch portal page data
const portalEntry = await useStatic('vuxen-portal', async () => {
  return await getPortalBySlug('vuxen')
})

// Transform portal data to match expected format
const page = computed(() => {
  if (!portalEntry) {
    // Fallback data if portal not found
    return {
      title: 'För vuxna',
      preamble: 'Här hittar du information för vuxna och pedagoger.',
      metadescription: 'Material för vuxna och pedagoger från Rädda Djuren-klubben.',
      tags: {
        links: [],
        moreLink: null,
      },
    }
  }
  return transformContentfulPortal(portalEntry)
})

// Fetch categories for vuxen portal
const categoriesResponse = await useStatic('vuxen-categories', async () => {
  return await getCategories({
    'fields.parent.fields.slug': 'vuxen',
    'fields.parent.sys.contentType.sys.id': 'portal',
    order: '-fields.title',
    include: 2, // Include linked assets
  } as any)
})

// Transform categories data
const categories = computed(() => {
  if (!categoriesResponse?.items) return []

  return categoriesResponse.items.map((category: Category) => ({
    ...transformContentfulCategory(category),
    id: category.sys.id,
  })) as any
})
</script>
